/**
 * Oficjalny adres kontaktowy platformy.
 *
 * ═══ JEDNO MIEJSCE, NIE OSIEM ═══
 * Adres pojawia się w stopce, w formularzu dla wykonawców i wszędzie tam, gdzie
 * użytkownik ma się z nami skontaktować. Wpisany na sztywno w każdym z tych miejsc
 * rozjechałby się przy pierwszej zmianie — a adres, pod który nikt nie odpisuje,
 * jest gorszy niż jego brak.
 *
 * DOMENA PRZYJMUJE POCZTĘ: voltvalue.pl ma rekordy MX (mx1/mx2.hostinger.com)
 * i SPF wskazujący na Hostinger. To co innego niż subdomena `send.voltvalue.pl`,
 * przez którą Resend WYSYŁA powiadomienia — tamta służy tylko do wysyłki.
 */
export const ADRES_KONTAKTOWY = 'kontakt@voltvalue.pl'

export default ADRES_KONTAKTOWY
